import { Button } from "@/components/ui/button";
import { ShinyButton } from "@/components/ui/shiny-button";
import { ArrowRight } from "lucide-react";

export default function CTASection({ onDemoClick }) {
  return (
    <section data-testid="cta-section" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-950/30 to-[#020611]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] bg-blue-600/20 blur-[140px] rounded-full" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter text-white leading-[1.0]">
          Recupere o seu tempo.<br />
          <span className="text-gradient-blue">Receba mais marcações.</span>
        </h2>
        <p className="mt-6 sm:mt-8 text-base sm:text-lg md:text-xl text-slate-400 max-w-2xl mx-auto font-light leading-relaxed">
          Em 15 minutos mostramos-lhe exactamente quanto tempo está a perder e como a Automia resolve isso hoje. Sem compromisso, sem cartão de crédito.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:items-center justify-center">
          <Button
            data-testid="cta-section-demo"
            onClick={onDemoClick}
            className="btn-primary-glow text-white border-0 rounded-full h-13 px-8 text-base font-medium group"
            style={{ height: "3.25rem" }}
          >
            Experimente 7 dias grátis
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
          <ShinyButton
            href="mailto:ola@automia.pt"
            data-testid="cta-section-email"
            className="inline-flex items-center justify-center h-[3.25rem] px-7"
          >
            ola@automia.pt
          </ShinyButton>
        </div>
      </div>
    </section>
  );
}
